
<div id="app">

  <obpp-header [langLabel]="langLabel"></obpp-header>

  <obpp-footer  [langLabel]="langLabel" (langClick)="langClick($event)"></obpp-footer>

</div>
